import { FC } from 'react'
import { NavLink, useSearchParams } from 'react-router-dom'
import { RenderIf } from 'components/RenderIf'
import { InfoItemProps } from 'featureSliced/widgets/Sidebar/InfoItem'

export const withNavLinkHOC =
  (Component: FC<InfoItemProps>): FC<InfoItemProps> =>
  ({ link, hideCover, ...rest }) => {
    const [searchParams] = useSearchParams()

    const getNavLink = (path = 'menu') => {
      const table = searchParams.get('table')
      if (table) {
        return `/${path}?table=${table}`
      } else {
        return `/${path}`
      }
    }

    return (
      <>
        <RenderIf condition={!!link}>
          <NavLink to={getNavLink(link as string)} onClick={hideCover}>
            <Component link={link} {...rest} />
          </NavLink>
        </RenderIf>
        <RenderIf condition={!link}>
          <Component {...rest} />
        </RenderIf>
      </>
    )
  }
